// react components
import React from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    Link,
} from 'react-router-dom'

// components
import {
    ImageHelperSite,
} from 'components'

// data
import {
    defaultReduxState,
    reduxSalesRemoveFromCartSite,
} from 'data'

// pages
import {
    PortfolioCheckoutSite,
} from 'pages'

// services
import {
} from 'services'

// main
export const CheckoutSite: React.FC = () => {

    const dispatch = useDispatch()
    const reduxCacheSite = useSelector((state: defaultReduxState) => state.reduxCacheSite)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxSalesSite = useSelector((state: defaultReduxState) => state.reduxSalesSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    if (!reduxCacheSite.portfolio?.is_eshop) return null

    return (
        <div className={`checkout-site ${deviceType}`}>
            <PortfolioCheckoutSite />
            <div className={`cs-content ${deviceType}`}>
                <div className={`cs-cart-list ${deviceType}`}>
                    <p className={`cs-cart-total ${deviceType}`}>
                        {reduxText[7465]}
                    </p>
                    {reduxSalesSite.salesLines.length === 0 && (
                        <p className={`cs-cart-empty ${deviceType}`}>
                            {reduxText[7466]}
                        </p>
                    )}
                    {reduxSalesSite.salesLines.map((val, i) => (
                        <div
                            key={`cs-lines-${i}`}
                            className={`cs-lines ${deviceType}`}
                        >
                            <Link
                                className={`cs-image-wrap ${deviceType}`}
                                to={val.absolute_url}
                            >
                                <ImageHelperSite
                                    alt={val.product.name}
                                    className={`cs-image ${deviceType}`}
                                    dominant_color={undefined}
                                    src={val.product.get_image_site_lq}
                                />
                            </Link>
                            <div className={`cs-info ${deviceType}`}>
                                <div className={`cs-info-wrap ${deviceType}`}>
                                    <span className={`cs-name ${deviceType}`}>
                                        {val.product.name}
                                    </span>
                                    {val.variant && (
                                        <span className={`cs-variant ${deviceType}`}>
                                            {val.variant.name}
                                        </span>
                                    )}
                                    {/* Package Options */}
                                    {val.package_option_items?.map((item) => (
                                        <span key={item.id} className={`cs-package-option ${deviceType}`}>
                                            {item.package_option?.name && `${item.package_option.name}: `}
                                            {item.product?.name}
                                            {item.qty ? ` (x${item.qty})` : ''}
                                        </span>
                                    ))}

                                    {/* Package Options Prices */}
                                    {val.package_option_items && val.package_option_items.length > 0 && (
                                        <div className={`cs-package-options-prices ${deviceType}`}>
                                            {val.package_option_items.map((item) => (
                                                <span key={`price-${item.id}`} className={`cs-package-option-price ${deviceType}`}>
                                                    {item.product?.name}: {item.qty} x {item.product?.unit_price || 0} {val.currency_symbol}
                                                </span>
                                            ))}
                                            {val.package_options_total && val.package_options_total > 0 && (
                                                <span className={`cs-package-options-total ${deviceType}`}>
                                                    Options total: {val.package_options_total} {val.currency_symbol}
                                                </span>
                                            )}
                                        </div>
                                    )}

                                    {/* Form Data */}
                                    {val.extra_data_json && Object.keys(val.extra_data_json).length > 0 && (
                                        <div className={`cs-form-data ${deviceType}`}>
                                            {/* Handle new structure with form data nested under 'form' key */}
                                            {val.extra_data_json.form && Object.keys(val.extra_data_json.form).length > 0 && (
                                                <>
                                                    {Object.entries(val.extra_data_json.form).map(([fieldName, fieldData]) => {
                                                        if (fieldData && typeof fieldData === 'object' && 'label' in fieldData && 'value' in fieldData) {
                                                            const { label, value } = fieldData as { label: string, value: any }
                                                            return (
                                                                <div key={fieldName} className={`cs-form-field ${deviceType}`}>
                                                                    <strong>{label}:</strong>{' '}
                                                                    {Array.isArray(value) ? value.join(', ') :
                                                                        typeof value === 'object' && value !== null && 'value' in value ? (value as any).value :
                                                                            typeof value === 'object' && value !== null && 'id' in value ? (value as any).id :
                                                                                String(value)}
                                                                </div>
                                                            )
                                                        }
                                                        return null
                                                    })}
                                                </>
                                            )}

                                            {/* Handle any other extra data keys (for future extensibility) */}
                                            {Object.entries(val.extra_data_json).map(([keyName, keyData]) => {
                                                // Skip the 'form' key as it's handled above
                                                if (keyName === 'form') return null

                                                // Handle other types of extra data
                                                let formattedValue: string
                                                if (Array.isArray(keyData)) {
                                                    formattedValue = keyData.join(', ')
                                                } else if (typeof keyData === 'object' && keyData !== null && 'value' in keyData) {
                                                    formattedValue = String((keyData as any).value)
                                                } else if (typeof keyData === 'object' && keyData !== null && 'id' in keyData) {
                                                    formattedValue = String((keyData as any).id)
                                                } else if (typeof keyData === 'object') {
                                                    formattedValue = JSON.stringify(keyData)
                                                } else {
                                                    formattedValue = String(keyData)
                                                }

                                                // Format the key name to be more readable
                                                const formattedKeyName = keyName
                                                    .replace(/_/g, ' ')
                                                    .replace(/\b\w/g, l => l.toUpperCase())

                                                return (
                                                    <div key={keyName} className={`cs-form-field ${deviceType}`}>
                                                        <strong>{formattedKeyName}:</strong>{' '}
                                                        {formattedValue}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}

                                    <span className={`cs-price ${deviceType}`}>
                                        {val.qty} x {val.unitPrice} {val.currency_symbol}
                                    </span>
                                </div>
                                <span className={`cs-line-total ${deviceType}`}>
                                    {val.lineTotal} {val.currency_symbol}
                                </span>
                            </div>
                            <div className={`cs-actions ${deviceType}`}>
                                <i
                                    onClick={() => dispatch(reduxSalesRemoveFromCartSite(i, reduxCacheSite.portfolio!))}
                                    className={`mo-new-icon-trash-solid ${deviceType}`}
                                />
                            </div>
                        </div>
                    ))}
                </div>
                <div className={`cs-footer ${deviceType}`}>
                    <p>{reduxText[7467]}{' '}{Number(reduxSalesSite.subTotal.toFixed(2))} {reduxSalesSite.currency_symbol}</p>
                </div>
            </div>
        </div>
    )
}
